// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__2SrXM","wrapper_description":"wrapper_description__p8p69","wrapper_label":"wrapper_label__2L9c6","grecaptcha":"grecaptcha__Lo6Jq","tip":"tip__16IHU"};